import { I18NextPipe } from 'angular-i18next';
import { ThresholdUnit } from 'mbs-ui-shared@models/Notification';

export const thresholdUnits = (i18N: I18NextPipe): { id: ThresholdUnit; name: string }[] => [
  {
    id: ThresholdUnit.Day,
    name: i18N.transform('shared:notifications.thresholdUnitDay', { count: 2, format: 'title' })
  },
  {
    id: ThresholdUnit.Hour,
    name: i18N.transform('shared:notifications.thresholdUnitHour', { count: 2, format: 'title' })
  }
];
